import { CustomFieldType } from '@/shared/types/types.generated';

export const normalizeCustomFieldDefaultValue = (
  fieldType: CustomFieldType,
  value: unknown,
) => {
  if (value === undefined) {
    return undefined;
  }

  if (value === null || value === '') {
    return null;
  }

  if (fieldType === CustomFieldType.Number) {
    return Number(value);
  }

  if (fieldType === CustomFieldType.Boolean) {
    if (typeof value === 'boolean') {
      return value;
    }

    return value === 'true';
  }

  if (fieldType === CustomFieldType.MultiSelect) {
    return Array.isArray(value) ? value.map(String) : [];
  }

  return String(value);
};

export const getCustomFieldFormDefaultValue = (
  fieldType: CustomFieldType,
  value: unknown,
) => {
  if (value === undefined || value === null) {
    return undefined;
  }

  if (fieldType === CustomFieldType.Boolean) {
    return Boolean(value);
  }

  if (fieldType === CustomFieldType.MultiSelect) {
    return Array.isArray(value) ? value.map(String) : [];
  }

  if (fieldType === CustomFieldType.Number) {
    return Number(value);
  }

  return String(value);
};

export const isValidUrl = (value: string) => {
  try {
    const url = new URL(value);
    return Boolean(url.protocol && url.host);
  } catch {
    return false;
  }
};
